const isNumString = str => !isNaN(Number(str))

export function deepParseJson(json) {
    if (typeof json === 'string') {
        if (isNumString(json)) return json
        try {
            return deepParseJson(JSON.parse(json))
        } catch {
            return json
        }
    }
    if (Array.isArray(json)) {
        return json.map(deepParseJson)
    }
    if (json && typeof json === 'object') {
        return Object.keys(json).reduce((obj, key) => {
            const val = json[key]
            obj[key] = isNumString(val) ? val : deepParseJson(val)
            return obj
        }, {})
    }
    return json
}

export function buildFormData(form, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
        Object.keys(data).forEach(key => {
            buildFormData(form, data[key], parentKey ? `${parentKey}[${key}]` : key)
        })
    } else {
        if (data instanceof Blob && parentKey === 'report') {
            form.append(parentKey, data === null ? '' : data, 'report.pdf')
        } else {
            form.append(parentKey, data === null ? '' : data)
        }
    }
}

export function createFormData(data) {
    const formData = new FormData()
    buildFormData(formData, data)
    return formData
}
